interface ProgressBarProps {
    value: number
    max: number
    className?: string
    showPercentage?: boolean
  }
  
  export function ProgressBar({ value, max, className = "", showPercentage = false }: ProgressBarProps) {
    const percentage = Math.min((value / max) * 100, 100)
  
    return (
      <div className={`w-full ${className}`}>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div className="bg-fluxi h-2 rounded-full transition-all duration-300" style={{ width: `${percentage}%` }} />
        </div>
        {showPercentage && <span className="text-sm text-gray-600 mt-1 block">{Math.round(percentage)}%</span>}
      </div>
    )
  }
  